import { render, staticRenderFns } from "./CustomersOnline.vue?vue&type=template&id=704d9780&scoped=true"
import script from "./CustomersOnline.vue?vue&type=script&lang=js"
export * from "./CustomersOnline.vue?vue&type=script&lang=js"
import style0 from "./CustomersOnline.vue?vue&type=style&index=0&id=704d9780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d9780",
  null
  
)

export default component.exports